import { render, staticRenderFns } from "./IaraSolicitacaoAutorizacaoTable.vue?vue&type=template&id=a09512fe&lang=pug"
import script from "./IaraSolicitacaoAutorizacaoTable.vue?vue&type=script&lang=js"
export * from "./IaraSolicitacaoAutorizacaoTable.vue?vue&type=script&lang=js"
import style0 from "./IaraSolicitacaoAutorizacaoTable.vue?vue&type=style&index=0&id=a09512fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports